import { useQuery } from '@apollo/client';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ChangeEvent, FC, useState } from 'react';
import Input from '../../../../components/form/input';
import { USERS_CLINICIAN_LIST } from '../../../../graphql/query/users';
import { GraphQLResponse, IUser } from '../../../../types';
import UsersManageClinicianList from './list';
import styles from './styles.module.css';

const UsersManageClinicianView: FC = () => {
  const [filter, setFilter] = useState('');

  const {
    loading,
    data: res,
    refetch,
  } = useQuery<GraphQLResponse<'listUsersClinician', IUser[]>>(USERS_CLINICIAN_LIST, {
    variables: { filter: filter.length >= 3 ? filter : '' },
  });

  const data = res?.listUsersClinician?.data;

  const handleUpdateFilter = (e: ChangeEvent<HTMLInputElement>) => {
    setFilter(e.target.value);
  };

  return (
    <div className={styles.wrapper}>
      {/* header area */}
      <div className={styles.header}>
        <div className={styles.inputWrapper}>
          <Input.Component
            placeholder="Search for clinician..."
            value={filter}
            onChange={handleUpdateFilter}
            style={{
              width: '100%',
              border: '0',
              backgroundColor: 'transparent',
              padding: '1rem 2rem 1rem 2.5rem',
            }}
            controlProps={{
              style: {
                width: '100%',
              },
            }}
            iconLeft={<FontAwesomeIcon icon={faSearch as IconProp} className={styles.inputIcon} />}
          />
        </div>
      </div>

      <UsersManageClinicianList show={data} isLoading={loading} refresh={refetch} />
    </div>
  );
};

export default UsersManageClinicianView;
